module.exports = __webpack_public_path__ + "static/media/mclaughlin_riviero_pinholster_rodriguez.05aa3965.jpg";